import React, { useState } from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import QuestionnaireForm from './Components/Pages/QuestionnaireForm';
import QuestionsList from './Components/Pages/QuestionsList ';
import Dashboard from './Components/Pages/Dashboard';
import Signup from './Components/Auth/Signup';
import Login from './Components/Auth/Login';
import QuizResults from './Components/Pages/QuizResults';
import Emailverification from './Components/Auth/Emailverification';
import Forgotpassword from './Components/Auth/ForgotPassword';
import ResetPassword from './Components/Auth/ResetPassword';
import Pollquestionform from './Components/Pages/PollQuestionForm';
import PollSelectform from './Components/Pages/Pollselectform';
import CreateNewEvent from './Components/Pages/CreteNewEvent';
import QuestionsList1 from './Components/Pages/QuestionsList1';
import Quiz from './Components/Quiz/Quiz';
import ViewQuiz from './Components/Quiz/ViewQuiz';
import LandingPage from './Components/LandingPage/LandingPage';
import HostLiveRoom from './Components/Pages/HostLiveRoom';
import ParticipantArena from './Components/Pages/ParticipantArena';
import CertificateDesigner from './Components/Pages/CertificateDesigner';
import AdminLogin from './Components/Auth/AdminLogin';
import AdminDashboard from './Components/AdminDashboard/AdminDashboard';
import SelfPacedArena from './Components/Pages/SelfPacedArena';


function App() {

  const [quizzes, setQuizzes] = useState([]);

  return (
    <Router>
      <Routes>

        <Route path='/PollSelectForm/:userId/:randomString/PollSelectForm' element={<PollSelectform />} />

        <Route path='/QuestionsList/:userId/:randomString/QuestionsList' element={<QuestionsList />} />
        <Route path='/QuestionsList/:userId/:randomString/QuestionsList1' element={<QuestionsList1 />} />
<Route path='/' element={<LandingPage />} />
        <Route path='/login' element={<Login />} />
        <Route path='/Dashboard/45g676tr/Dashboard' element={<Dashboard />} />
        <Route path='/Signup/45g676tr/Signup' element={<Signup />} />
        <Route path='/QuizResults/45g63476tr/QuizResults' element={<QuizResults />} />
        <Route path='/otp-verification' element={<Emailverification />} />
        <Route path='/forgotPassword' element={<Forgotpassword />} />
        <Route path='/resetpassword/:resetToken' element={<ResetPassword />} />
        <Route path='/PollQuestionForm/45g63476tr/PollQuestionForm' element={<Pollquestionform />} />
        <Route path='/QuestionnaireForm/253643/QuestionnaireForm' element={<QuestionnaireForm />} />
        <Route path='/createnewevent/25g4643' element={<CreateNewEvent />} />
<Route path="/HostLiveRoom/:roomPin" element={<HostLiveRoom />} />
{/* Inside your App.jsx Routes */}
<Route path="/PlayerRoom/:roomPin" element={<ParticipantArena />} />
<Route path="/join" element={<ParticipantArena />} />
<Route path="/certificate-designer" element={<CertificateDesigner />} />
<Route path="/quiz/:quizCode" element={<SelfPacedArena />} />
<Route path="/admin-login" element={<AdminLogin />} />
<Route path="/admin/dashboard" element={<AdminDashboard />} />
        <Route path="/quiz" element={<Quiz submittedQuizzes={quizzes} setSubmittedQuizzes={setQuizzes} />} />
        <Route path="/view-quiz/:quizId" element={<ViewQuiz quizzes={quizzes} />} />

      </Routes>
    </Router>
  );
}

export default App;
